import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "basis-4 w-3" }
const _hoisted_2 = {
  key: 0,
  class: "h-2.5 w-2.5 rounded-full bg-green mt-2 ml-1"
}
const _hoisted_3 = {
  key: 1,
  class: "h-2.5 w-2.5 rounded-full bg-red mt-2 ml-1"
}
const _hoisted_4 = { class: "basis-1/3" }
const _hoisted_5 = ["tabindex", "value", "max"]
const _hoisted_6 = { class: "basis-1/3" }
const _hoisted_7 = ["tabindex", "value", "max"]
const _hoisted_8 = { class: "basis-1/3 text-center" }
const _hoisted_9 = { class: "text-sm text-gray-900 bg-transparent mt-1" }

import { useStore } from "@/stores/game";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gamePlayerRound',
  props: ["playerIndex", "roundIndex"],
  setup(__props) {

const props = __props

const game = useStore();

const round = game.players[props.playerIndex].rounds[props.roundIndex];
const tabindex = props.roundIndex * 10 + props.playerIndex;

const setFocus = (event: any) => {
  event.target.select();
};

const updateResult = (event: any) => {
  game.updateResult(props.roundIndex, props.playerIndex, event);
};

const updatePrediction = (event: any) => {
  game.updatePrediction(props.roundIndex, props.playerIndex, event);
};

const isActive = computed(() => {
  return props.roundIndex == game.firstActiveRound;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row gap-1 md:gap-2 justify-start justify-items-center", { turn: _unref(round).turn, 'bg-blue-100': _unref(isActive) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(round).turn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (_unref(round).start)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        tabindex: tabindex + 1,
        type: "number",
        value: _unref(round).prediction,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (updatePrediction($event))),
        class: "block py-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue peer",
        required: "",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (setFocus($event))),
        min: "0",
        max: _unref(round).id
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("input", {
        tabindex: tabindex + 2,
        type: "number",
        value: _unref(round).result,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (updateResult($event))),
        class: "block py-1 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue peer",
        required: "",
        onFocus: _cache[3] || (_cache[3] = ($event: any) => (setFocus($event))),
        min: "0",
        max: _unref(round).id
      }, null, 40, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(round).score), 1)
    ])
  ], 2))
}
}

})